import React, { Fragment, useState, useEffect } from "react";
import { set_page_state } from "../../../../redux/actions/PageStateAction";
import { set_store } from "../../../../redux/actions/CreateStoreAction";
import { connect } from "react-redux";
import { FileUploadPromise } from "../../../../utils/aws_s3/aws_s3";
import DropzoneElement from "../../../../components/Dropzone/DropzoneElement";
import { type } from "../../../../components/Dropzone/type";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import * as Yup from "yup";
import { apiJson } from "../../../../api/Api";

const StoreSchema = Yup.object().shape({
  country_id: Yup.number().required("Required"),
  // name_ar: Yup.string().required("مطلوب"),
  name_en: Yup.string().required("Required"),
  // authorized_signatory_name_ar: Yup.string().required("مطلوب"),
  authorized_signatory_name_en: Yup.string().required("Required"),
  description_en: Yup.string().required("Required"),
  contact_email: Yup.string().email("Must be valid email").required("Required"),
  business_website: Yup.string().url("This must be URL").required("Required"),
  no_of_sku: Yup.number("Must be number")
    .min(1, "Must be greater than 1")
    .required("Required"),
  logo_image: Yup.string().required("Required"),
  store_address: Yup.string().required("Required"),
});

const StoreForm = (props) => {
  const [data, setData] = useState(true);
  const [loading, setLoading] = useState(false);
  const storeValues = {
    name_ar: props.store?.name_ar || "",
    description_ar: props.store?.description_ar || "",
    name_en: props.store?.name_en || "",
    authorized_signatory_name_en: props.store?.authorized_signatory_name_en || "",
    authorized_signatory_name_ar: props.store?.authorized_signatory_name_ar || "",
    description_en: props.store?.description_en || "",
    contact_email: props.store?.contact_email || "",
    business_website: props.store?.business_website || "",
    logo_image: props.store?.logo_image || "",
    no_of_sku: props.store?.no_of_sku || "",
    store_address: props.store?.store_address || "",
  };

  const countryValues = [
    { value: null, label: "Select Country" },
    { value: 1, label: "UAE" },
    { value: 2, label: "KSA" },
    { value: 3, label: "Egypt" },
  ];
  const [country, setCountry] = useState(countryValues[0]);

  const handleChange = (c) => {
    setCountry(c);
  };

  let message = "";
  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    props.store.country_id && setCountry(countryValues[props.store.country_id - 1]);
    // eslint-disable-next-line
  }, []);

  const nextClick = (value) => {    
    setLoading(true);
    apiJson.createStore
      .validateName({
        store_name_en: value.name_en,
        store_name_ar: value.name_ar,
      })
      .then((response) => {
        setLoading(false);
        if (response.success) {
          apiJson.createStore
            .createStore({
              country_id: parseInt(value.country_id),
              name_ar: value.name_ar,
              description_ar: value?.description_ar
                ? value?.description_ar
                : value?.description_en,
              name_en: value.name_en,
              authorized_signatory_name_en: value.authorized_signatory_name_en,
              authorized_signatory_name_ar: value.authorized_signatory_name_ar,
              description_en: value.description_en,
              contact_email: value.contact_email,
              business_website: value.business_website,
              logo_image: value.logo_image,
              no_of_sku: value.no_of_sku,
              store_address: value.store_address
            })
            .then(response => {
              if (response.success) {
                props.set_store({
                  store: {
                    ...props.store,
                    id: response.data.id,
                    country_id: parseInt(value.country_id),
                    name_ar: value.name_ar,
                    description_ar: value?.description_ar
                      ? value?.description_ar
                      : value?.description_en,
                    name_en: value.name_en,
                    authorized_signatory_name_en: value.authorized_signatory_name_en,
                    authorized_signatory_name_ar: value.authorized_signatory_name_ar,
                    description_en: value.description_en,
                    contact_email: value.contact_email,
                    business_website: value.business_website,
                    logo_image: value.logo_image,
                    no_of_sku: value.no_of_sku,
                    store_address: value.store_address,
                    country_id: value.country_id
                  },
                });
                props.set_page_state({ pageState: { id: 3 } });
              }
              else {
                message = response.message;
                showError();
              }
            })
            .catch(error => {
              message = "Something went wrong!";
              showError();
            })
        } else if (!response.status) {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        } else {
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
  };

  const handleFilesChange = (e, setFieldValue) => {
    setData(false);
    FileUploadPromise(e[0])
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          setFieldValue("logo_image", response.location);
          setData(true);
        }
      })
      .catch((error) => {
        setData(true);
        message = error
          ? error !== ""
            ? error
            : "something went wrong"
          : "something went wrong";
        showError();
      });
  };

  return (
    <Fragment>
      <Formik
        initialValues={storeValues}
        validationSchema={StoreSchema}
        isValidating={true}
        enableReinitialize={true}
        onSubmit={(values) => nextClick(values)}
      >
        {({ errors, touched, values, setFieldValue }) => {
          return (
            <Form className="form mx-auto">
              <label>Select Country</label>
              <Field
                as="select"
                name="country_id"
                label="Store Name"
                className="country-dropdown"
              >
                {
                  countryValues?.map((value) => (
                    <option value={value.value}>{value.label}</option>
                  ))
                }
              </Field>
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="name_en"
                type="text"
                label="Store Name"
                disabled={false}
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="authorized_signatory_name_en"
                type="text"
                label="Authorized Signatory Name"
                disabled={false}
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="contact_email"
                type="email"
                label="Email"
                disabled={false}
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="description_en"
                type="text"
                label="Description"
                multiline
                rows={4}
                disabled={false}
              />

              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="name_ar"
                type="text"
                label="اسم المتجر"
                className="arabic"
                disabled={false}
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="authorized_signatory_name_ar"
                type="text"
                label="اسم المُوقّع المُصرّح له"
                disabled={false}
                className="arabic"
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="description_ar"
                type="text"
                label="وصف"
                className="arabic"
                multiline
                rows={4}
                disabled={false}
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="no_of_sku"
                type="number"
                label="No. of SKU"
                disabled={false}
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="business_website"
                type="text"
                label="Website Link"
                disabled={false}
              />
              <Field
                style={{ width: '100%', marginBottom: '60px' }}
                component={TextField}
                name="store_address"
                type="text"
                label="Address"
                disabled={false}
              />
              {data ? (
                <Fragment>
                  <DropzoneElement
                    multiple={false}
                    updateSelectedServiceFiles={(e) =>
                      handleFilesChange(e, setFieldValue)
                    }
                    value={
                      values.logo_image !== ""
                        ? "logo.png"
                        : "Select Logo Image(png,jpeg,etc.)"
                    }
                    type={type.IMAGE}
                  />
                  {touched.logo_image && errors.logo_image && (
                    <div
                      className="error"
                      style={{
                        position: "relative",
                        left: "0",
                        color: "#f44336",
                        marginTop: "3px",
                        fontSize: "0.75rem",
                      }}
                    >
                      {errors.logo_image}
                    </div>
                  )}
                </Fragment>
              ) : (
                <div className="d-flex justify-content-center align-items-center w-100 h-100">
                  <ClipLoader color="#000" loading size={35} />
                </div>
              )}
              <br />
              <button key={72325} type="submit" className="next-button">
                {!loading ? (
                  "Next"
                ) : (
                  <ClipLoader color="#000" loading size={20} />
                )}
              </button>
            </Form>
          );
        }}
      </Formik>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    store: state.store.store,
  };
};

const mapDispatchTopProps = { set_store, set_page_state };

export default connect(mapStateToProps, mapDispatchTopProps)(StoreForm);
